import { useEffect as c } from "react";
import "../../jsx-runtime-C5mzlN2N.js";
import "../../NotificationList-DGxPKGSY.js";
import { a as f } from "../../hooks-DVuc7it1.js";
import { isNotificationMeta as u } from "./utils.es.js";
const m = (s) => {
  const {
    meta: t,
    type: r,
    enqueueNotification: e
  } = s;
  r === "success" && t.success ? e({
    variant: "success",
    title: t.success.title,
    message: t.success.message,
    id: t.success.id
  }) : r === "error" && t.error && e({
    variant: "warning",
    title: t.error.title,
    message: t.error.message,
    id: t.error.id
  });
}, p = (s) => {
  const {
    meta: t,
    enqueueNotification: r
  } = s, e = {
    variant: "warning",
    title: "Failed to retrieve data",
    message: "Please refresh the page or if the error persists, try again later."
  };
  if (u(t == null ? void 0 : t.notification) && t.notification.error) {
    const o = t.notification.error;
    e.title = o.title, e.message = o.message || "", e.id = o.id;
  }
  r(e);
}, q = (s) => {
  const {
    queryClient: t
  } = s, r = t.getMutationCache(), e = t.getQueryCache(), {
    enqueueNotification: o
  } = f();
  c(() => {
    const a = r.subscribe((i) => {
      var n;
      !i.mutation || i.type !== "updated" || !u((n = i.mutation.meta) == null ? void 0 : n.notification) || m({
        meta: i.mutation.meta.notification,
        type: i.action.type,
        enqueueNotification: o
      });
    });
    return () => {
      a();
    };
  }, []), c(() => {
    const a = e.subscribe((i) => {
      i.type === "updated" && i.action.type === "error" && p({
        meta: i.query.meta,
        enqueueNotification: o
      });
    });
    return () => {
      a();
    };
  }, []);
};
export {
  q as useQueryMutationHandler
};
